import React from "react";

import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import TournamentContactInfo from "../../components/Tournament/TournamentContactInfo";
import TournamentSubpageHead from "../../components/SEO/TournamentSubpageHead";
import { useTournamentId, useTournamentSlug } from "../../context/TournamentRouteContext";
import { tournamentPath } from "../../utility/tournamentUrls";

const TournamentContacts = () => {
  const tournamentId = useTournamentId();
  const tournamentSlug = useTournamentSlug();

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Tournaments", path: "/tournaments" },
    { label: "Tournament", path: tournamentPath(tournamentSlug) },
    { label: "Contacts" },
  ];

  return (
    <>
      <TournamentSubpageHead page="contacts" />
      <div className="flex justify-center mb-3 sm:mb-4 px-4 sm:px-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="card-board overflow-hidden">
        <div className="bg-brand-charcoal text-brand-cream px-6 py-4">
          <h1 className="font-display font-bold text-xl text-brand-cream tracking-tight">
            Contacts
          </h1>
          <p className="text-sm text-brand-mist mt-1">
            People to contact about this tournament.
          </p>
        </div>
        <TournamentContactInfo
          tournamentId={tournamentId}
          className="p-6"
          showHeading={false}
        />
      </div>
    </>
  );
};

export default TournamentContacts;
